import { config } from '../../../core/config/config';

export const removeUserFromReport = async (
  token: string,
  report_id: string,
  user_ids: string[]
) => {
  try {
    const uri = `${config.uri.lp_backend}/reports/analytics/remove-user`;
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ report_id, user_ids })
    };

    const response = await fetch(uri, options);

    return response.ok;
  } catch (err) {
    throw err;
  }
};
